module.exports = __webpack_public_path__ + "image/icon_service_video.png";